import { slug } from 'utils';

function placeKitten(scale) {
  const unit = 2 * scale;
  return `//placekitten.com/${16*unit}/${9*unit}`;
}

function getSlug(item) {
  return `${item.id}/${slug(item.name).toLowerCase()}`;
}

function copy(o) {
  return JSON.parse(JSON.stringify(o));
}

export function listTeams() {
  return Object.keys(teams).map(id => getTeam(id));
}

export function getTeam(id) {
  const team = {
    id,
    name: teams[id].name,
    players: listPlayers(teams[id].playerIds)
  };

  team.urlSlug = getSlug(team);

  return team;
}

export function listPlayers(idList = Object.keys(players)) {
  return idList.map(function(id) {
    const zeros = {played: {started: 0, onAsSub: 0}, assists: 0, goals: 0, yellowCards: 0, redCards: 0};
    const player = getPlayer(id);

    player.stats = player.stats.reduce(function(c, p) {
      return {
        played: {
          started: p.played.started + c.played.started,
          onAsSub: p.played.onAsSub + c.played.onAsSub
        },
        assists: p.assists + c.assists,
        goals: p.goals + c.goals,
        yellowCards: p.yellowCards + c.yellowCards,
        redCards: p.redCards + c.redCards
      };
    }, zeros);

    return player;
  });
}

export function getPlayer(id) {
  const player = copy(players[id]);

  player.id = id;
  player.urlSlug = getSlug(player);

  return player;
}

const teams = {
  "123": {name: "Beatles United" , playerIds: ["1", "2", "3", "4"]},
  "234": {name: "Stones Affletic", playerIds: ["5", "6", "7", "8", "9"]}
};

const players = {
  "1": {
    name: "John",
    img: placeKitten(20),
    shirtNumber: 3,
    dob: "09-Oct-1940",
    pob: "Woolton",
    position: "Guitar",
    club: "Beatles United",
    stats: [
      {competition: "Some League", played: {started: 1, onAsSub: 0}, assists: 0, goals: 0, yellowCards: 0, redCards: 0}
    ],
    transfers: [
      {from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1"}
    ]
  },
  "2": {
    name: "Paul",
    img: placeKitten(21),
    shirtNumber: 11,
    dob: "18-Jun-1942",
    pob: "Allerton",
    position: "Bass",
    club: "Beatles United",
    stats: [
      {competition: "Some League",    played: {started: 1, onAsSub: 2}, assists: 1, goals: 1, yellowCards: 0, redCards: 0},
      {competition: "Another League", played: {started: 2, onAsSub: 0}, assists: 4, goals: 0, yellowCards: 0, redCards: 0}
    ],
    transfers: [
      {from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1"},
      {from: "Another Club", to: "Some Club", date: "26-Dec-2016", fee: "£2"}
    ]
  },
  "3": {
    name: "George",
    img: placeKitten(22),
    shirtNumber: 26,
    dob: "25-Feb-1943",
    pob: "Wavertree",
    position: "Guitar",
    club: "Beatles United",
    stats: [
      {competition: "Some League", played: {started: 1, onAsSub: 2}, assists: 2, goals: 1, yellowCards: 0, redCards: 0},
      {competition: "A Cup",       played: {started: 0, onAsSub: 1}, assists: 3, goals: 7, yellowCards: 6, redCards: 1}
    ],
    transfers: [
      {from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1"}
    ]
  },
  "4": {
    name: "Ringo",
    img: placeKitten(23),
    shirtNumber: 49,
    dob: "07-Jul-1940",
    pob: "Dingle",
    position: "Drums",
    club: "Beatles United",
    stats: [
      {competition: "Some League", played: {started: 3, onAsSub: 0}, assists: 1, goals: 2, yellowCards: 1, redCards: 0},
      {competition: "A Cup",       played: {started: 0, onAsSub: 1}, assists: 0, goals: 7, yellowCards: 6, redCards: 1},
      {competition: "Another Cup", played: {started: 1, onAsSub: 0}, assists: 8, goals: 0, yellowCards: 0, redCards: 1}
    ],
    transfers: [
      {from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1"}
    ]
  },

  "5": {
    name: "Mick",
    img: placeKitten(24),
    shirtNumber: 1,
    dob: "26-Jul-1943",
    pob: "Dartford",
    position: "Vocals",
    club: "Stones Affletic",
    stats: [
      {competition: "Another Cup", played: {started: 1, onAsSub: 0}, assists: 8, goals: 0, yellowCards: 0, redCards: 1}
    ],
    transfers: [
      {from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1"}
    ]
  },
  "6": {
    name: "Keith",
    img: placeKitten(25),
    shirtNumber: 13,
    dob: "18-Dec-1943",
    pob: "Dartford",
    position: "Guitar",
    club: "Stones Affletic",
    stats: [
      {competition: "Some League", played: {started: 4, onAsSub: 0}, assists: 2, goals: 1, yellowCards: 1, redCards: 0},
      {competition: "Another Cup", played: {started: 1, onAsSub: 1}, assists: 2, goals: 0, yellowCards: 3, redCards: 0}
    ],
    transfers: [
      {from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1"}
    ]
  },
  "7": {
    name: "Charlie",
    img: placeKitten(26),
    shirtNumber: 42,
    dob: "02-Jun-1941",
    pob: "Kingsbury",
    position: "Drums",
    club: "Stones Affletic",
    stats: [
      {competition: "Some League", played: {started: 1, onAsSub: 0}, assists: 6, goals: 0, yellowCards: 0, redCards: 4}
    ],
    transfers: [
      {from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1"}
    ]
  },
  "8": {
    name: "Ronnie",
    img: placeKitten(27),
    shirtNumber: 6,
    dob: "01-Jun-1947",
    pob: "Hillingdon",
    position: "Guitar",
    club: "Stones Affletic",
    stats: [
      {competition: "Some League", played: {started: 1, onAsSub: 2}, assists: 3, goals: 4, yellowCards: 5, redCards: 6},
      {competition: "A Cup",       played: {started: 1, onAsSub: 2}, assists: 3, goals: 4, yellowCards: 5, redCards: 6}
    ],
    transfers: [
      {from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1"}
    ]
  },
  "9": {
    name: "Bill",
    img: placeKitten(28),
    shirtNumber: 13,
    dob: "24-Oct-1936",
    pob: "Lewisham",
    position: "Bass",
    club: "Stones Affletic",
    stats: [
      {competition: "Some League", played: {started: 2, onAsSub: 0}, assists: 0, goals: 0, yellowCards: 1, redCards: 2},
      {competition: "A Cup",       played: {started: 1, onAsSub: 0}, assists: 0, goals: 0, yellowCards: 2, redCards: 1},
      {competition: "Another Cup", played: {started: 4, onAsSub: 0}, assists: 0, goals: 0, yellowCards: 3, redCards: 0}
    ],
    transfers: [
      {from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1"}
    ]
  }
};




// WEBPACK FOOTER //
// ./modules/Football/reducers/mockData/MockTeamAndPlayerData.js